var React = require('react');

function Icon2Inline (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"fill":"#ef7800","d":"M38.266 25.453h-16.01v1.78h.89c.49 0 .889.397.889.888v8.895a.89.89 0 0 1-.89.89h-3.558a.89.89 0 0 1-.889-.89v-8.895c0-.49.399-.889.89-.889h.888v-3.558h16.01v-7.115H32.93v1.783a1.784 1.784 0 0 1-1.779 1.778H11.583a1.785 1.785 0 0 1-1.78-1.782V13a1.785 1.785 0 0 1 1.78-1.78H31.15a1.784 1.784 0 0 1 1.779 1.78v1.779h5.337zM23.282.473C10.808.472.696 10.583.696 23.057s10.112 22.586 22.586 22.586c12.474 0 22.586-10.112 22.586-22.586C45.868 10.584 35.756.472 23.282.472z"}))));
}

Icon2Inline.defaultProps = {"width":"46","height":"46","viewBox":"0 0 46 46"};

module.exports = Icon2Inline;

Icon2Inline.default = Icon2Inline;
